function initialize() {
    $('.page-press select[name="category"]').on('change', function (evt) {
        const category = $(".page-press select[name='category'] option:selected").val();
        if ($(this).val()) {
            goPress(category, $(this).val());
        }
    });
}

function goPress(category, uf) {
    let url = '/sobre-nos/imprensa';

    if (category) {
        url += '/' + category;
    }

    window.location = url;
}

initialize();
